// extracted by mini-css-extract-plugin
export default {"title":"ConfirmationSuccessPage_title__ZeML4"};